/** D5 → A5 gentle dual-tone chime (Web Audio API, no audio files). */
const D5_HZ = 587.33;
const A5_HZ = 880;
const CHIME_DURATION_SEC = 0.35;
const PEAK_GAIN = 0.08;

let sharedCtx: AudioContext | null = null;

function getAudioContext(): AudioContext | null {
  if (typeof window === "undefined") return null;
  const Ctx =
    window.AudioContext ||
    (window as unknown as { webkitAudioContext?: typeof AudioContext })
      .webkitAudioContext;
  if (!Ctx) return null;
  if (!sharedCtx || sharedCtx.state === "closed") {
    sharedCtx = new Ctx();
  }
  return sharedCtx;
}

function playTone(
  ctx: AudioContext,
  frequency: number,
  startOffsetSec: number,
  durationSec: number
) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = "sine";
  osc.frequency.value = frequency;

  const start = ctx.currentTime + startOffsetSec;
  const end = start + durationSec;
  gain.gain.setValueAtTime(0, start);
  gain.gain.linearRampToValueAtTime(PEAK_GAIN, start + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.001, end);

  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(start);
  osc.stop(end + 0.02);
}

/**
 * Plays a short notification chime (D5 then A5, soft decay ~350ms).
 * Safe to call without user gesture after a prior unlock; failures are ignored.
 */
export function playNotificationSound(): void {
  try {
    const ctx = getAudioContext();
    if (!ctx) return;
    if (ctx.state === "suspended") {
      void ctx.resume();
    }
    const half = CHIME_DURATION_SEC / 2;
    playTone(ctx, D5_HZ, 0, half + 0.05);
    playTone(ctx, A5_HZ, half * 0.7, half + 0.08);
  } catch {
    // Autoplay / AudioContext restrictions — ignore.
  }
}
